import API_BASE_URL from '../config/api';

const authHeaders = () => {
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const subscribeToNewsletter = async ({
  email,
  source = 'website',
  preferences = {},
}) => {
  const res = await fetch(`${API_BASE_URL}/newsletter/subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, source, preferences }),
  });
  const json = await res.json();
  if (!res.ok)
    throw new Error(json?.message || 'Failed to subscribe to newsletter');
  return json.data || json;
};

export const getNewsletterStats = async () => {
  const res = await fetch(`${API_BASE_URL}/newsletter/stats`, {
    headers: { ...authHeaders() },
  });
  const json = await res.json();
  if (!res.ok)
    throw new Error(json?.message || 'Failed to fetch newsletter stats');
  return json.data;
};

export const getNewsletterSubscribers = async (params) => {
  const queryString =
    params instanceof URLSearchParams
      ? params.toString()
      : new URLSearchParams(params).toString();

  const res = await fetch(
    `${API_BASE_URL}/newsletter/subscribers?${queryString}`,
    {
      headers: { ...authHeaders() },
    }
  );
  const json = await res.json();
  if (!res.ok)
    throw new Error(json?.message || 'Failed to fetch newsletter subscribers');

  return {
    subscribers: json.data || [],
    pagination: {
      total: json.total || 0,
      pages: json.pages || 0,
      page: json.currentPage || 1,
      limit: parseInt(params.get?.('limit')) || 10,
    },
  };
};

export const getNewsletterExportUrl = (status = 'active') => {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  return `${API_BASE_URL}/newsletter/export?${params.toString()}`;
};

export const sendNewsletter = async ({ subject, content, targetAudience }) => {
  const res = await fetch(`${API_BASE_URL}/newsletter/send`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
    },
    body: JSON.stringify({ subject, content, targetAudience }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to send newsletter');
  return json.data || json;
};
